import Spinner from 'react-bootstrap/Spinner';
export const PreloaderComponent = ({
  message = 'Loading...',
}: {
  message?: string;
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
      <Spinner animation="border" size="sm" role="status">
        <span className="visually-hidden">{message}</span>
      </Spinner>
      <span> {message}</span>
    </div>
  );
};
